import { default as CheckboxUikit } from '@rio-cloud/rio-uikit/Checkbox';
import * as React from 'react';
import type { WrappedFieldProps } from 'redux-form';

interface CustomProps {
    checkboxLabel?: React.ReactNode;
}

class Checkbox extends React.Component<CustomProps & WrappedFieldProps> {
    render() {
        const {
            input: { value, onChange },
            checkboxLabel,
        } = this.props;
        return (
            <CheckboxUikit checked={value} onClick={onChange}>
                {checkboxLabel}
            </CheckboxUikit>
        );
    }
}

export default Checkbox;
